import { render, staticRenderFns } from "./TableBalanceRecurringEmail.vue?vue&type=template&id=5f0f2282&"
import script from "./TableBalanceRecurringEmail.vue?vue&type=script&lang=js&"
export * from "./TableBalanceRecurringEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports